import { SUB_TYPE } from './constant.js';
import { subElementToHtml } from './element-to-html.js';
import { subHtmlToElement } from './html-to-element.js';
import { subPlugin } from './plugin.js';
import { subRenderElement } from './render-element.js';
import { subSerializer } from './serializer.js';

const SubModule = {
  type: SUB_TYPE,
  renderElement: subRenderElement,
  elementToHtml: subElementToHtml,
  htmlToElement: subHtmlToElement,
  plugin: subPlugin,
  serializer: subSerializer
};

export { SubModule };
//# sourceMappingURL=module.js.map
